import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { connect } from "react-redux"
import React, { Component } from "react"
import { createAction } from "redux-actions"
import { Helmet } from "react-helmet";
import Logo from "../../assets/newblacklogo.png"
import BlueCheckmark from "../../assets/blue-checkmark.png"
import FaLock from 'react-icons/lib/fa/lock'
import { setCookie } from '../../misc/utilities'
import ReCAPTCHA from "react-google-recaptcha";
import { browserHistory, Link } from 'react-router'
import "./checkout.css"
import SignInWidget from '../signin/SignInWidget'
import {
  userSubscribePlan,
  SUBSCRIBE,
  EDIT_USER,
  log,
  resendVerificationEmail,
} from "../../actions"

if (typeof window !== 'undefined') {
  require('rc-tooltip/assets/bootstrap.css')
}


const mapStateToProps = (state, ownProps) => {
  const { me, checkout, query } = state
  return {
    checkout,
    me,
    viewParams: ownProps.viewParams
  }
}

class Checkout extends Component {
  stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)
  recaptchaRef = React.createRef();

  constructor() {
    super()

    this.state = {
      provider: 'stripe',
      action: 'signup',
      monthly: null
    }
  }

  isMonthly() {
    if (this.state.monthly == null) {
      return this.props.viewParams.query.monthly
    }
    return this.state.monthly
  }

  getPlan() {
    return this.props.me.plan_options[this.isMonthly() ? 'monthly' : 'annual'].stripe_id
  }

  reset() {
    this.props.dispatch(createAction(EDIT_USER)({ error: null, message: null }))
  }

  componentDidMount() {
    const self = this;
    const { me, dispatch, viewParams } = this.props
    const { query } = viewParams


    var PAYPAL_SCRIPT = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&vault=true&disable-funding=venmo,credit,card`;
    var script = document.createElement('script');
    script.setAttribute('src', PAYPAL_SCRIPT);
    script.setAttribute('data-namespace', 'paypal_api');
    script.onload = function() {
      console.log("Paypal script loaded!");
      window.paypal_api.Buttons({
        style: {
          color: 'blue',
          shape: 'rect',
          size: 'medium',
          height: 40
        },

        createSubscription: function(data, actions) {
          dispatch(log("CHECKOUT PAYPAL, CREATING SUBSCRIPTION - " + me.user_name))

          const planOption = me.plan_options[self.isMonthly() ? 'monthly' : 'annual']
          let planId = planOption.paypal_id
          if (me.no_trial && planOption.paypal_id_notrial) {
            planId = planOption.paypal_id_notrial
          }

          return actions.subscription.create({
            "custom_id": me.user_name,
            'application_context': { 
              'shipping_preference': "NO_SHIPPING",
              'user_action': 'CONTINUE'
            },
            'plan_id': planId
          });
        },
      
        onError: async function(err) {
          dispatch(log("CHECKOUT PAYPAL SUBSCRIPTION FAILED - " + err.toString()))
          dispatch(createAction(SUBSCRIBE)(new Error(err.toString())))
        },

        onCancel: async function(data) {

        },

        onApprove: async function(data, actions) {
          dispatch(log("CHECKOUT PAYPAL, SUBSCRIPTION APPROVED - " + me.user_name + "(" + data.subscriptionID + ")"))

          const plan = self.getPlan();
          
          try {
            const user = await dispatch(userSubscribePlan(null, plan, data.subscriptionID, null, query.src_internal, me.no_trial))
            setCookie('dashboard', 'true', 90000)
            window.location = `/?alert=${plan}&subscribed=true&src_internal=${query.src_internal}`
          } catch(error) {
            dispatch(log("CHECKOUT PAYPAL SUBSCRIPTION FAILED - " + error))
          }
        }
        
      }).render('#paypal');
    }
    document.head.appendChild(script);
  }

  switchProvider(provider) {
    this.setState({ provider })
  }

  render() {
    const self = this
    const { dispatch, checkout, me, viewParams } = this.props
    const { query } = viewParams

    if (me.plan) {
      browserHistory.push('/')
      return (<div></div>)
    }

    return (
      <div className="checkout">
        <Helmet>
          <title>Checkout - Streamable</title>
          <meta name="description" content="Checkout on Streamable"></meta>
          <link rel="canonical" href={`https://streamable.com/checkout`} />
        </Helmet>
        <div className="checkout-container">
          <div className="info">
            <div className="plan-title">
              Streamable Pro
            </div>
            <div className="info-header">
              {me.no_trial ? '1-Step Checkout' : 'Free 7-day trial'}
            </div>
            <div className="features">
              <div className="feature">
                <div className="feature-header">What's included in Pro?</div>
                <div className="feature-content">No upload limits, no ads on your videos, 2TB cloud storage, 4K support and more.</div>
              </div>
              <div className="feature">
                <div className="feature-header">Can I cancel anytime?</div>
                <div className="feature-content">Yup, you can cancel whenever you want from your account settings.</div>
              </div>
              {me.no_trial ? 
                <div className="feature">
                  <div className="feature-header">What if I'm unsatisfied?</div>
                  <div className="feature-content">If you're unhappy with your purchase, contact our support team for a full refund.</div>
                </div>
              :
                <div className="feature">
                  <div className="feature-header">Will my card be charged today?</div>
                  <div className="feature-content">Nope! You'll only be charged if you don't cancel your trial before it ends.</div>
                </div>
              }
            </div>
            <div className="back">
              <Link to={`/pricing?src_internal=${query.src_internal}`}>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="long-arrow-left" role="img" viewBox="0 0 448 512"><path fill="currentColor" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z"/></svg>
              Compare plans and pricing
              </Link>
            </div>
          </div>
          <div className={`checkout-box ${me.user_name ? 'payment' : 'signin'} ${me.no_trial ? 'notrial': ''}`}>
            <div className="card">
              {me.user_name ?
                me.hosting_provider && !me.email_verified ?
                  <div>
                    <h3>Email Verification Required</h3>
                    <div className="subtext">Please check your inbox for further instructions. Didn't get it? <a href="#" onClick={e => {
                        e.preventDefault()
                        dispatch(resendVerificationEmail())
                        .then(() => this.setState({verificationSent: true}))
                        }}>
                        {this.state.verificationSent ? 'Sent' : 'Resend Email'}.
                      </a>
                    </div>
                  </div>
                :
                  <div>
                    <img className="logo" style={{'width': '40px', 'height': '40px', objectPosition: 'left', objectFit: 'cover'}} src={Logo} role="presentation" />
                    <h3>Billing Details</h3>
                    <div className="subtext">You will not be charged today.</div>
                    <div className="plans">
                      <div className={`plan ${!this.isMonthly() ? 'selected' : ''}`} onClick={e => this.setState({monthly: false})}>
                        <div className="radio"></div>
                        <div className="plan-text">
                          <span className="price">${me.plan_options ? (me.plan_options.annual.price / 12).toFixed(2) : ''} per month</span> <span className="annual-discount">Save 40%</span>
                          <div className="duration">Billed annually{me.no_trial ? '' : ' after 7-day free trial'}</div>
                        </div>
                        
                      </div>
                      <div className={`plan ${this.isMonthly()? 'selected' : ''}`} onClick={e => this.setState({monthly: true})}>
                        <div className="radio"></div>
                        <div className="plan-text">
                          <span className="price">${me.plan_options ? me.plan_options.monthly.price : ''} per month</span>
                          <div className="duration">Billed monthly{me.no_trial ? '' : ' after 7-day free trial'}</div>
                        </div>
                        
                      </div>
                    </div>
                    <div className="separator"></div>
                    <div className="providers">
                      <button className={`provider ${this.state.provider == 'stripe' ? 'selected' : ''}`} onClick={e => this.setState({provider: "stripe"})}>
                        <div className="radio"></div>
                        <img draggable={false} className="cc-logo" src="https://statics.streamable.com/static/cards/1.png" role="presentation" />
                        <img draggable={false} className="cc-logo" src="https://statics.streamable.com/static/cards/2.png" role="presentation" />
                        <img draggable={false} className="cc-logo" src="https://statics.streamable.com/static/cards/22.png" role="presentation" />
                        <img draggable={false} className="cc-logo hide-small" src="https://statics.streamable.com/static/cards/14.png" role="presentation" />
                      </button>
                      <button className={`provider ${this.state.provider == 'paypal' ? 'selected' : ''}`} onClick={e => this.setState({provider: "paypal"})}>
                        <div className="radio"></div>
                        <img draggable={false} className="paypal_logo" src='https://statics.streamable.com/static/cards/paypal.png' role="presentation" />
                      </button>
                    </div>
                    {this.state.provider == 'stripe' ? 
                      <Elements stripe={this.stripePromise}>
                        <ElementsConsumer>
                          {({elements, stripe}) => (
                            <form
                              onSubmit={async (e) => {

                                const plan = this.getPlan();

                                e.preventDefault();

                                if (me.plan) {
                                  dispatch(createAction(SUBSCRIBE)(new Error("You are already subscribed to a plan. Please contact support@streamable.com for help.")))
                                  return
                                }
                                
                                if (!stripe || !elements) {
                                  return;
                                }
                                dispatch(createAction(SUBSCRIBE)({purchasing: true}))

                                const cardElement = elements.getElement(CardElement);
                            
                                const {error, paymentMethod} = await stripe.createPaymentMethod({
                                  type: 'card',
                                  card: cardElement,
                                });

                                this.setState({ error })
                            
                                if (error) {
                                  dispatch(log("CHECKOUT CARD ERROR - " + error.message))
                                  dispatch(createAction(SUBSCRIBE)(new Error(error.message)))
                                  return
                                }
                                
                                stripe.createPaymentMethod({
                                  type: 'card',
                                  card: cardElement,
                                }).then(async (result, email) => {
                                  if (result.error) {
                                    dispatch(log("CHECKOUT CARD ERROR - " + error.message))
                                    dispatch(createAction(SUBSCRIBE)(new Error(result.error)))
                                  } else {
                                    dispatch(log("CHECKOUT RECAPTCHA SHOWN"))
                                    const start = Date.now()
                                    const token = await self.recaptchaRef.current.executeAsync();
                                    const delta = Date.now() - start
                                    dispatch(log("CHECKOUT RECAPTCHA TOKEN RETURNED IN " + delta.toString() + "ms"))
                                    self.recaptchaRef.current.reset()

                                    try {
                                      const user = await dispatch(userSubscribePlan(result.paymentMethod.id, plan, null, token, query.src_internal, me.no_trial))
                                      setCookie('dashboard', 'true', 90000)
                                      window.location = `/?alert=${plan}&subscribed=true&src_internal=${query.src_internal}`
                                    } catch(error) {
                                      dispatch(log("CHECKOUT STRIPE SUBSCRIPTION FAILED - " + error))
                                    }
                                  }
                                })
                              }}
                            >
                              <CardElement
                                onReady={() => {
                                  this.props.dispatch(createAction(SUBSCRIBE)({ purchasing: false, error: false, message: null }))
                                }}
                                options={{
                                  hidePostalCode: false,
                                  style: {
                                    base: {
                                      fontSize: '16px',
                                      color: 'rgb(116, 132, 144)',
                                      fontFamily: 'Open Sans, sans-serif',
                                      fontSize: '1rem',
                                      border: '1px solid #ced4da',
                                      '::placeholder': {
                                        color: '#aaa',
                                      },
                                    },
                                    invalid: {
                                      color: '#9e2146',
                                    },
                                  },
                                }}
                              />
                              {checkout.error ? <div className="alert alert-warning">{checkout.message}</div> : ''}
                              <div className="separator"></div>
                              {me.plan_options ?
                                <div className="bill">
                                  <div className="due-today">Total due today:</div>
                                  <div className="total-cost">${this.isMonthly() ? me.plan_options.monthly.price : me.plan_options.annual.price}</div>
                                  <div className="trial-cost">$0</div>
                                </div>
                              : ''}
                              <button
                                id="submit"
                                type="submit"
                                className={`blue-button ${checkout.purchasing || !stripe ? 'disabled': ''}`}
                                disabled={checkout.purchasing || !stripe}
                              >
                                {me.no_trial ? 'Upgrade Now' : 'Begin Trial'}
                              </button>
                              <div style={{ clear: "both" }} />    
                              <ReCAPTCHA
                                ref={this.recaptchaRef}
                                size="invisible"
                                sitekey="6LefNMAZAAAAANHI6PRR6Vh9yMBsCmipPTw8jPOP"
                              />                        
                            </form>
                          )}
                          </ElementsConsumer>
                        </Elements>
                      : 
                      <div style={{marginTop: '16px', marginBottom: '12px', color: 'black', fontWeight: 600, fontSize: '12px'}}>
                        You will be sent to PayPal to complete your signup.
                      </div>
                    }
                    
                  </div>
              : 
                <div>
                  <img className="logo" style={{'width': '40px', 'height': '40px', objectPosition: 'left', objectFit: 'cover'}} src={Logo} role="presentation" />
                  <h3>{this.state.action == 'signup' ? 'Sign Up' : 'Log in'}</h3>
                  <div className="subtext">to start your <b>Free 7-day trial</b></div>
                  <div className="separator"></div>
                  <SignInWidget 
                    action={this.state.action} 
                    buttonText="Continue"
                    verificationRedirect="https://streamable.com/upgrade" 
                    onDone={() => {}} 
                  />
                </div>
              }
              <div id="paypal" style={{
                height: '40px', 
                pointerEvents: checkout.purchasing ? 'none' : 'auto', 
                filter: checkout.purchasing ? 'grayscale(1)' : '', 
                display: this.state.provider == 'paypal' && me.user_name ? 'block' : 'none'
              }} />
            </div>
            {me.user_name ?
              <div className="footer">
                <FaLock /> Secured by SSL encryption
              </div>
            :
              <div className="switcher">
                {this.state.action == 'signup' ?
                  <a href='#' onClick={e => {
                    this.reset();
                    this.setState({'action': 'login'})
                  }}>Already have an account? <span className="action">Log in.</span></a>
                :
                  <a href='#' onClick={e => {
                    this.reset();
                    this.setState({'action': 'signup'})
                  }}>Don't have an account? <span className="action">Join now.</span></a>
                }
              </div>
          }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Checkout)
